<template>
  <AppAside class="aside-for-links">
    <div class="right-panel">
      <div class="tab-right">
        <span class="tab-label-text">Online services</span>
        <span>
          Skip the trip! Use online DMV services below. Find links for your
          {{ isBusinessUser ? 'registration' : 'license and registration' }}
          specific services underneath your
          {{ isBusinessUser ? 'Registration' : 'License and Registration' }}.
        </span>
        <div class="links">
          <ul>
            <li class="tab-content-list">
              <a href="#" @click.prevent="newReservation()">Make a new Reservation</a>
            </li>
            <li>
              <a href="https://www.ri.gov/DMV/mvr/" target="_blank" rel="noopener noreferrer">Licensed Driver Records</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </AppAside>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import * as COMMONS from '../../store/_commons';
import AppAside from './AppAside.vue';

const emit = defineEmits(['doCheckReservation']);

const store = useStore();
//Reactive data 
const onlineToken = ref('');
const errMsgForReservation = ref(false);

//Computed properties
const isBusinessUser = computed(() => store.state.guestLogin.isBusinessUser);
const personalInfo = computed(() => store.getters[COMMONS.GUEST_PERSONAL_INFO]);
const onlineTokenLocalStorage = computed(() => localStorage.getItem('onlineToken'));

// Watcher
watch(onlineToken, (value) => {
  console.log('Update value for data', value);
  window.close();
});

watch(onlineTokenLocalStorage, (value) => {
  console.log('UPDATE VALUE for computed', value);
  window.close();
});

// Lifecycle hook
onMounted(() => {

});

// Methods
const getIsEligibleForReservation = () => store.dispatch(COMMONS.GUEST_ELIGIBLE_FOR_RESERVATION);

const newReservation = async () => {
  const isEligibleForReservation = await getIsEligibleForReservation();

  if (isEligibleForReservation) {
    const baseUrl = window?.config?.WEB_CLIENT_URL ?? '';
    const token = encodeURIComponent(store.state.guestLogin.accessToken);
    const userType = personalInfo.value?.personalInformation?.customerType === 1 ? 1 : 2; // 1 for INDIVIDUAL, 2 for BUSINESS
    const url = `${baseUrl}type?onlineToken=${token}&customerType=${userType}`;
    window.open(url);
    return;
  }

  // Not eligible
  window.scrollTo(0, 0);
  emit('doCheckReservation', true);
  errMsgForReservation.value = true;
};
</script>

<style scoped lang="scss">
.app-notice {
  padding: 1rem;
  width: 20%;
}
.aside-for-links {
  img {
    margin-left: 0.5em;
    width: 0.75rem;
  }
  .right-panel{
    .tab-right {
      .tab-label-text{
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        cursor: pointer;
        margin-bottom: 1rem;
        &::after {
          content: none; 
        }
      }
      .links{
        ul {
          li {
            margin-top: 1rem;
          }
        }
      }
    }
  }

  .app-alert-error {
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 28px;
    padding-left: 10px;
    padding-right: 10px;
      
  }
  .reservation-err-msg{
    position: absolute;
    top: -25px;
    left: 0;
    margin: 0 15px;
    width: 80%;

    .res-err{
      .btn-close {
        position: absolute;
        right: 0;
        top: 0;
        min-width: 40px;
        max-width: 40px;
        border: 0px;
        background-color: transparent;
        color: black;
      }
    }
  }
}
@media only screen and (max-width: 599px) {
  .app-notice {
    width: 100%;
    margin-top: 1rem;
  }

  .reservation-err-msg {
    width: 100% !important;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1024px) {
  .app-notice {
    max-width: unset;
    width: unset;
    margin-top: 1rem;
  }
}
</style>